import { usePublicRecordsForOrderArgs } from './usePublicRecordsForOrderArgs.ts';
import { usePublicRecordsFromListings } from './usePublicRecordsFromListings.ts';
import { useTkv2OrderID } from './useTkv2OrderID.ts';

export function usePublicRecordsForOrder() {
  const orderID = useTkv2OrderID();
  const { listings, addressesByID } = usePublicRecordsForOrderArgs();

  return usePublicRecordsFromListings({ orderID }, listings, addressesByID);
}
